import { createStore } from 'effector';
import { OrgPortalSettings } from '@nx-frontend/shared/types';

const initialOrgPortalSettingsState: OrgPortalSettings[] = [];

export const $orgPortalSettings = createStore<OrgPortalSettings[]>(initialOrgPortalSettingsState);
